/* ★2026-07-24 F1-b:`gridClass()`(视口断点版)与 <MediaGrid> 已删 —— 唯一消费者 `/works`
   改用 `styles/work-card.css` 的 `.work-grid` **容器查询**版。理由是实测:侧栏展开时容器
   ≈ 视口 − 304px,视口断点会量错对象 —— 视口 780(容器 476)按 `md:grid-cols-4` 切 4 列,
   卡宽只有 107px;视口 1280(容器 976)按 `xl:grid-cols-6` 切 6 列,卡宽从 275 跌到 149。 */

/**
 * 批量打包下载一次最多几项(与后端 PosterService.MAX_BATCH_TASKS 同步)。
 * 2026-07-10 50→10:每任务最多 4 张 4K PNG、后端内存打 zip,50 任务单请求可到数百 MB;
 * 收紧到 10(≤40 图)防打爆堆,「全选本页(24)」不再整页入包。
 */
export const BATCH_DOWNLOAD_MAX = 10;

/** 批量 id clamp 到上限(海报批下等用)。 */
export function clampBatchIds<T>(ids: T[], max: number = BATCH_DOWNLOAD_MAX): T[] {
  return ids.length > max ? ids.slice(0, max) : ids;
}
